import getSearchStringFromFilterOptions from './getSearchStringFromFilterOptions';

export const FILTER_OPTIONS_PARAMETER = 'filterOptions';

export default function passesKeywordsFilter(item, filter, searchFields, excludedSearchAttr) {
    // If no keyword supplied, then the item passes without question
    if (!filter.values.length) { return true; }

    const filterKeywords = filter.values.map(v => v.toLowerCase().replace(/®|™+/g, '').split(' '));
    const filterWordsArray = [].concat(...filterKeywords);
    // For each field specified in the strings array, build a string to search through - if not specified we search the title and excerpt
    const stringFields = (searchFields && searchFields.length) ? searchFields : ['title', 'excerpt'];
    let searchString = '';


    stringFields.forEach(field => {
        // Handle arrays differently
        if (field === FILTER_OPTIONS_PARAMETER && Array.isArray(item[field])) {
            searchString += getSearchStringFromFilterOptions(item, field, excludedSearchAttr);
        } else if (Array.isArray(item[field])) {
            searchString += item[field].join(' ').toLowerCase();
        } else {
            searchString += `${item[field]} `.toLowerCase();
        }
        // exclude characters ® and ™ from the search
        searchString = searchString.replace(/®|™+/g, '');
        // replace &amp; with &
        searchString = searchString.replace(/&amp;/g, '&');
    });

    const isEvery = filterWordsArray.every(f => searchString.includes(f));

    // Return the item if the string contains every keyword
    return isEvery;
}
